/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { JsonApiLinksDto } from "../JsonApiLinksDto";
import type { PaginationMeta } from "../PaginationMeta";

export type HierarchiesControllerGetDescendantsPathParams = {
    /**
     * @description Scope ID
     * @type string
    */
    scopeId: string;
};

export const hierarchiesControllerGetDescendantsQueryParamsScopeTypeEnum = {
    "ORGANIZATION": "ORGANIZATION",
    "PROMPT": "PROMPT",
    "FILE": "FILE",
    "PROJECT": "PROJECT",
    "SYSTEM": "SYSTEM",
    "WORKSPACE": "WORKSPACE",
    "TEAM": "TEAM",
    "FOLDER": "FOLDER",
    "USER": "USER",
    "CHAT_MESSAGE": "CHAT_MESSAGE",
    "CLIENT": "CLIENT",
    "THREAD": "THREAD",
    "PROJECT_TYPE": "PROJECT_TYPE",
    "OWNER": "OWNER",
    "ARCHITECT": "ARCHITECT",
    "DEPARTMENT": "DEPARTMENT",
    "REGION": "REGION",
    "CHECKLIST_TEMPLATE": "CHECKLIST_TEMPLATE",
    "TRIAL": "TRIAL",
    "CHANGE_ORDER": "CHANGE_ORDER",
    "SOURCE_RECORD": "SOURCE_RECORD",
    "all": "all"
} as const;

export type HierarchiesControllerGetDescendantsQueryParamsScopeTypeEnumKey = (typeof hierarchiesControllerGetDescendantsQueryParamsScopeTypeEnum)[keyof typeof hierarchiesControllerGetDescendantsQueryParamsScopeTypeEnum];

export const hierarchiesControllerGetDescendantsQueryParamsExcludeFileStatusesEnum = {
    "PENDING": "PENDING",
    "UPLOADING": "UPLOADING",
    "UPLOADED": "UPLOADED",
    "PROCESSING": "PROCESSING",
    "READY": "READY",
    "FAILED": "FAILED",
    "ARCHIVED": "ARCHIVED",
    "DELETED": "DELETED",
    "VERSIONED": "VERSIONED"
} as const;

export type HierarchiesControllerGetDescendantsQueryParamsExcludeFileStatusesEnumKey = (typeof hierarchiesControllerGetDescendantsQueryParamsExcludeFileStatusesEnum)[keyof typeof hierarchiesControllerGetDescendantsQueryParamsExcludeFileStatusesEnum];

export const hierarchiesControllerGetDescendantsQueryParamsFileDocumentTypesEnum = {
    "PRIME_CONTRACT": "PRIME_CONTRACT",
    "SUBCONTRACT": "SUBCONTRACT",
    "SPECIFICATIONS": "SPECIFICATIONS",
    "DRAWING": "DRAWING",
    "DRAWING_SET": "DRAWING_SET",
    "OTHER": "OTHER"
} as const;

export type HierarchiesControllerGetDescendantsQueryParamsFileDocumentTypesEnumKey = (typeof hierarchiesControllerGetDescendantsQueryParamsFileDocumentTypesEnum)[keyof typeof hierarchiesControllerGetDescendantsQueryParamsFileDocumentTypesEnum];

export type HierarchiesControllerGetDescendantsQueryParams = {
    /**
     * @description Type(s) of scope for filtering descendant scopes. Can be a single type or comma-separated list (e.g., FILE,FOLDER)
     * @type string
    */
    scopeType: HierarchiesControllerGetDescendantsQueryParamsScopeTypeEnumKey;
    /**
     * @description Maximum depth of hierarchy to retrieve
     * @minLength 1
     * @default 5
     * @type number | undefined
    */
    maxDepth?: number;
    /**
     * @description Load children lazily (returns links for children instead of full data)
     * @default false
     * @type boolean | undefined
    */
    lazyLoadChildren?: boolean;
    /**
     * @description Number of items per page
     * @minLength 1
     * @maxLength 100
     * @default 20
     * @type number | undefined
    */
    pageSize?: number;
    /**
     * @description Page number for offset-based pagination
     * @minLength 1
     * @default 1
     * @type number | undefined
    */
    page?: number;
    /**
     * @description Sort field and order (prefix with - for descending)
     * @type string | undefined
    */
    sort?: string;
    /**
     * @description Search term to filter children by entity name (and description/referenceNumber for projects). Case-insensitive partial match.
     * @type string | undefined
    */
    search?: string;
    /**
     * @description Include soft-deleted entities (teams, organizations, clients) in the response. Default is false.
     * @default false
     * @type boolean | undefined
    */
    includeDeleted?: boolean;
    /**
     * @description Return only archived projects, folders and files. This is what the Archive listing reads; it overrides includeArchived.
     * @default false
     * @type boolean | undefined
    */
    archiveView?: boolean;
    /**
     * @description Include archived projects, folders and files in the response. Default is false, so an archived item leaves the active listing the way a deleted one does.
     * @default false
     * @type boolean | undefined
    */
    includeArchived?: boolean;
    /**
     * @description Include the scope itself (the scopeId used in the request) in the ancestor results. Default is false.
     * @default false
     * @type boolean | undefined
    */
    includeSelf?: boolean;
    /**
     * @description File statuses to exclude from results. Can be a single status or comma-separated list (e.g., \"PENDING,UPLOADING\")
     * @type array | undefined
    */
    excludeFileStatuses?: HierarchiesControllerGetDescendantsQueryParamsExcludeFileStatusesEnumKey[];
    /**
     * @description Document types to filter FILE children by. Can be a single type or comma-separated list (e.g., \"PRIME_CONTRACT,SUBCONTRACT\"). Unlike excludeFileStatuses, this narrows results to files only — non-FILE children (folders) are excluded while it is active.
     * @type array | undefined
    */
    fileDocumentTypes?: HierarchiesControllerGetDescendantsQueryParamsFileDocumentTypesEnumKey[];
    /**
     * @description Load entity data (folder.name, file.fileName, etc.) so results carry real display names. Set false when only counts/structure are needed, to skip the entity joins. Default is true; ignored (forced on) when a search term is present, since name filtering requires it.
     * @default true
     * @type boolean | undefined
    */
    includeEntities?: boolean;
};

export const dataTypeEnum3255 = {
    "hierarchies": "hierarchies"
} as const;

export type DataTypeEnum3255Key = (typeof dataTypeEnum3255)[keyof typeof dataTypeEnum3255];

export const attributesTypeEnum10 = {
    "ORGANIZATION": "ORGANIZATION",
    "TEAM": "TEAM",
    "PROJECT": "PROJECT",
    "FILE": "FILE",
    "FOLDER": "FOLDER",
    "CLIENT": "CLIENT"
} as const;

export type AttributesTypeEnum10Key = (typeof attributesTypeEnum10)[keyof typeof attributesTypeEnum10];

export const dataTypeEnum3256 = {
    "organizations": "organizations"
} as const;

export type DataTypeEnum3256Key = (typeof dataTypeEnum3256)[keyof typeof dataTypeEnum3256];

export const dataTypeEnum3257 = {
    "teams": "teams"
} as const;

export type DataTypeEnum3257Key = (typeof dataTypeEnum3257)[keyof typeof dataTypeEnum3257];

export const dataTypeEnum3258 = {
    "projects": "projects"
} as const;

export type DataTypeEnum3258Key = (typeof dataTypeEnum3258)[keyof typeof dataTypeEnum3258];

export const dataTypeEnum3259 = {
    "files": "files"
} as const;

export type DataTypeEnum3259Key = (typeof dataTypeEnum3259)[keyof typeof dataTypeEnum3259];

export const dataTypeEnum3260 = {
    "folders": "folders"
} as const;

export type DataTypeEnum3260Key = (typeof dataTypeEnum3260)[keyof typeof dataTypeEnum3260];

export const dataTypeEnum3261 = {
    "clients": "clients"
} as const;

export type DataTypeEnum3261Key = (typeof dataTypeEnum3261)[keyof typeof dataTypeEnum3261];

export const includedTypeEnum2195 = {
    "hierarchies": "hierarchies"
} as const;

export type IncludedTypeEnum2195Key = (typeof includedTypeEnum2195)[keyof typeof includedTypeEnum2195];

export const includedTypeEnum2196 = {
    "organizations": "organizations"
} as const;

export type IncludedTypeEnum2196Key = (typeof includedTypeEnum2196)[keyof typeof includedTypeEnum2196];

export const dataTypeEnum3262 = {
    "scopes": "scopes"
} as const;

export type DataTypeEnum3262Key = (typeof dataTypeEnum3262)[keyof typeof dataTypeEnum3262];

export const dataTypeEnum3263 = {
    "trial-summaries": "trial-summaries"
} as const;

export type DataTypeEnum3263Key = (typeof dataTypeEnum3263)[keyof typeof dataTypeEnum3263];

export const dataTypeEnum3264 = {
    "domains": "domains"
} as const;

export type DataTypeEnum3264Key = (typeof dataTypeEnum3264)[keyof typeof dataTypeEnum3264];

export const includedTypeEnum2197 = {
    "teams": "teams"
} as const;

export type IncludedTypeEnum2197Key = (typeof includedTypeEnum2197)[keyof typeof includedTypeEnum2197];

export const dataTypeEnum3265 = {
    "users": "users"
} as const;

export type DataTypeEnum3265Key = (typeof dataTypeEnum3265)[keyof typeof dataTypeEnum3265];

export const dataTypeEnum3266 = {
    "principals": "principals"
} as const;

export type DataTypeEnum3266Key = (typeof dataTypeEnum3266)[keyof typeof dataTypeEnum3266];

export const dataTypeEnum3267 = {
    "offices": "offices"
} as const;

export type DataTypeEnum3267Key = (typeof dataTypeEnum3267)[keyof typeof dataTypeEnum3267];

export const includedTypeEnum2198 = {
    "projects": "projects"
} as const;

export type IncludedTypeEnum2198Key = (typeof includedTypeEnum2198)[keyof typeof includedTypeEnum2198];

export const dataTypeEnum3268 = {
    "sample-project-templates": "sample-project-templates"
} as const;

export type DataTypeEnum3268Key = (typeof dataTypeEnum3268)[keyof typeof dataTypeEnum3268];

export const dataTypeEnum3269 = {
    "project-types": "project-types"
} as const;

export type DataTypeEnum3269Key = (typeof dataTypeEnum3269)[keyof typeof dataTypeEnum3269];

export const dataTypeEnum3270 = {
    "owners": "owners"
} as const;

export type DataTypeEnum3270Key = (typeof dataTypeEnum3270)[keyof typeof dataTypeEnum3270];

export const dataTypeEnum3271 = {
    "architects": "architects"
} as const;

export type DataTypeEnum3271Key = (typeof dataTypeEnum3271)[keyof typeof dataTypeEnum3271];

export const dataTypeEnum3272 = {
    "departments": "departments"
} as const;

export type DataTypeEnum3272Key = (typeof dataTypeEnum3272)[keyof typeof dataTypeEnum3272];

export const dataTypeEnum3273 = {
    "regions": "regions"
} as const;

export type DataTypeEnum3273Key = (typeof dataTypeEnum3273)[keyof typeof dataTypeEnum3273];

export const dataTypeEnum3274 = {
    "external-project-links": "external-project-links"
} as const;

export type DataTypeEnum3274Key = (typeof dataTypeEnum3274)[keyof typeof dataTypeEnum3274];

export const includedTypeEnum2199 = {
    "files": "files"
} as const;

export type IncludedTypeEnum2199Key = (typeof includedTypeEnum2199)[keyof typeof includedTypeEnum2199];

export const includedTypeEnum2200 = {
    "folders": "folders"
} as const;

export type IncludedTypeEnum2200Key = (typeof includedTypeEnum2200)[keyof typeof includedTypeEnum2200];

export const includedTypeEnum2201 = {
    "clients": "clients"
} as const;

export type IncludedTypeEnum2201Key = (typeof includedTypeEnum2201)[keyof typeof includedTypeEnum2201];

export const includedTypeEnum2202 = {
    "scopes": "scopes"
} as const;

export type IncludedTypeEnum2202Key = (typeof includedTypeEnum2202)[keyof typeof includedTypeEnum2202];

export const includedTypeEnum2203 = {
    "trial-summaries": "trial-summaries"
} as const;

export type IncludedTypeEnum2203Key = (typeof includedTypeEnum2203)[keyof typeof includedTypeEnum2203];

export const includedTypeEnum2204 = {
    "domains": "domains"
} as const;

export type IncludedTypeEnum2204Key = (typeof includedTypeEnum2204)[keyof typeof includedTypeEnum2204];

export const includedTypeEnum2205 = {
    "users": "users"
} as const;

export type IncludedTypeEnum2205Key = (typeof includedTypeEnum2205)[keyof typeof includedTypeEnum2205];

export const dataTypeEnum3275 = {
    "user-preferences": "user-preferences"
} as const;

export type DataTypeEnum3275Key = (typeof dataTypeEnum3275)[keyof typeof dataTypeEnum3275];

export const includedTypeEnum2206 = {
    "offices": "offices"
} as const;

export type IncludedTypeEnum2206Key = (typeof includedTypeEnum2206)[keyof typeof includedTypeEnum2206];

export const includedTypeEnum2207 = {
    "principals": "principals"
} as const;

export type IncludedTypeEnum2207Key = (typeof includedTypeEnum2207)[keyof typeof includedTypeEnum2207];

export const dataTypeEnum3276 = {
    "members": "members"
} as const;

export type DataTypeEnum3276Key = (typeof dataTypeEnum3276)[keyof typeof dataTypeEnum3276];

export const dataTypeEnum3277 = {
    "principalRoles": "principalRoles"
} as const;

export type DataTypeEnum3277Key = (typeof dataTypeEnum3277)[keyof typeof dataTypeEnum3277];

export const includedTypeEnum2208 = {
    "sample-project-templates": "sample-project-templates"
} as const;

export type IncludedTypeEnum2208Key = (typeof includedTypeEnum2208)[keyof typeof includedTypeEnum2208];

export const includedTypeEnum2209 = {
    "project-types": "project-types"
} as const;

export type IncludedTypeEnum2209Key = (typeof includedTypeEnum2209)[keyof typeof includedTypeEnum2209];

export const includedTypeEnum2210 = {
    "owners": "owners"
} as const;

export type IncludedTypeEnum2210Key = (typeof includedTypeEnum2210)[keyof typeof includedTypeEnum2210];

export const includedTypeEnum2211 = {
    "architects": "architects"
} as const;

export type IncludedTypeEnum2211Key = (typeof includedTypeEnum2211)[keyof typeof includedTypeEnum2211];

export const includedTypeEnum2212 = {
    "departments": "departments"
} as const;

export type IncludedTypeEnum2212Key = (typeof includedTypeEnum2212)[keyof typeof includedTypeEnum2212];

export const includedTypeEnum2213 = {
    "regions": "regions"
} as const;

export type IncludedTypeEnum2213Key = (typeof includedTypeEnum2213)[keyof typeof includedTypeEnum2213];

export const includedTypeEnum2214 = {
    "external-project-links": "external-project-links"
} as const;

export type IncludedTypeEnum2214Key = (typeof includedTypeEnum2214)[keyof typeof includedTypeEnum2214];

export const includedTypeEnum2215 = {
    "user-preferences": "user-preferences"
} as const;

export type IncludedTypeEnum2215Key = (typeof includedTypeEnum2215)[keyof typeof includedTypeEnum2215];

export const includedTypeEnum2216 = {
    "members": "members"
} as const;

export type IncludedTypeEnum2216Key = (typeof includedTypeEnum2216)[keyof typeof includedTypeEnum2216];

export const dataTypeEnum3278 = {
    "roles": "roles"
} as const;

export type DataTypeEnum3278Key = (typeof dataTypeEnum3278)[keyof typeof dataTypeEnum3278];

export const dataTypeEnum3279 = {
    "scope-access": "scope-access"
} as const;

export type DataTypeEnum3279Key = (typeof dataTypeEnum3279)[keyof typeof dataTypeEnum3279];

export const includedTypeEnum2217 = {
    "principalRoles": "principalRoles"
} as const;

export type IncludedTypeEnum2217Key = (typeof includedTypeEnum2217)[keyof typeof includedTypeEnum2217];

export type HierarchiesControllerGetDescendants200 = {
    /**
     * @type array
    */
    data: {
        /**
         * @type string
        */
        id: string;
        type: DataTypeEnum3255Key;
        /**
         * @description Resource attributes (excluding relationships)
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            type?: AttributesTypeEnum10Key;
            parentId?: (string | null);
            /**
             * @type number | undefined
            */
            depth?: number;
            /**
             * @type string | undefined
            */
            path?: string;
            /**
             * @type boolean | undefined
            */
            private?: boolean;
            /**
             * @type string | undefined
            */
            name?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            archivedAt?: (string | null);
            organization?: (object | null);
            team?: (object | null);
            project?: (object | null);
            file?: (object | null);
            folder?: (object | null);
            client?: (object | null);
            /**
             * @type boolean | undefined
            */
            isArchived?: boolean;
            /**
             * @type string | undefined
            */
            itemCount?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            children?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3255Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            parent?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3255Key;
                });
            };
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3256Key;
                });
            };
            /**
             * @type object | undefined
            */
            team?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3257Key;
                });
            };
            /**
             * @type object | undefined
            */
            project?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3258Key;
                });
            };
            /**
             * @type object | undefined
            */
            file?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3259Key;
                });
            };
            /**
             * @type object | undefined
            */
            folder?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3260Key;
                });
            };
            /**
             * @type object | undefined
            */
            client?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3261Key;
                });
            };
        };
    }[];
    /**
     * @description Additional resources referenced by the data
     * @type array | undefined
    */
    included?: ({
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2195Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            type: string;
            /**
             * @type string | undefined
            */
            parentId?: string;
            /**
             * @type string | undefined
            */
            depth?: string;
            /**
             * @type string | undefined
            */
            path?: string;
            /**
             * @type string | undefined
            */
            private?: string;
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            archivedAt?: string;
            /**
             * @type string | undefined
            */
            organization?: string;
            /**
             * @type string | undefined
            */
            team?: string;
            /**
             * @type string | undefined
            */
            project?: string;
            /**
             * @type string | undefined
            */
            file?: string;
            /**
             * @type string | undefined
            */
            folder?: string;
            /**
             * @type string | undefined
            */
            client?: string;
            /**
             * @type string | undefined
            */
            isArchived?: string;
            /**
             * @type string | undefined
            */
            itemCount?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            children?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3255Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            parent?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3255Key;
                });
            };
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3256Key;
                });
            };
            /**
             * @type object | undefined
            */
            team?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3257Key;
                });
            };
            /**
             * @type object | undefined
            */
            project?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3258Key;
                });
            };
            /**
             * @type object | undefined
            */
            file?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3259Key;
                });
            };
            /**
             * @type object | undefined
            */
            folder?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3260Key;
                });
            };
            /**
             * @type object | undefined
            */
            client?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3261Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2196Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            salesforceId?: string;
            /**
             * @type string | undefined
            */
            trimbleIamAccountId?: string;
            /**
             * @type string | undefined
            */
            trimbleCdhAccountId?: string;
            /**
             * @type string | undefined
            */
            ssoEnabled?: string;
            /**
             * @type string | undefined
            */
            dataProtectionEnabled?: string;
            /**
             * @type string | undefined
            */
            organizationSkillsEnabled?: string;
            /**
             * @type string | undefined
            */
            emsValidationEnabled?: string;
            /**
             * @type string | undefined
            */
            archivedProjectChatEnabled?: string;
            /**
             * @type string | undefined
            */
            archivedContentChatEnabled?: string;
            /**
             * @type string | undefined
            */
            apiAccessEnabled?: string;
            /**
             * @type string | undefined
            */
            isInternal?: string;
            /**
             * @type string | undefined
            */
            enabledIntegrations?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
            /**
             * @type string | undefined
            */
            entitlement?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3262Key;
                });
            };
            /**
             * @type object | undefined
            */
            trial?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3263Key;
                });
            };
            /**
             * @type object | undefined
            */
            clients?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3261Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            domains?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3264Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            teams?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3257Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            folders?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3260Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            files?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3259Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            children?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3255Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            descendants?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3255Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2197Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            salesforceId?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3262Key;
                });
            };
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3256Key;
                });
            };
            /**
             * @type object | undefined
            */
            members?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3265Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            createdBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3266Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3266Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3266Key;
                });
            };
            /**
             * @type object | undefined
            */
            createdByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3265Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3265Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3265Key;
                });
            };
            /**
             * @type object | undefined
            */
            sourceOffice?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3267Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2198Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            visibility?: string;
            /**
             * @type string | undefined
            */
            stage?: string;
            /**
             * @type string | undefined
            */
            location?: string;
            /**
             * @type string | undefined
            */
            startDate?: string;
            /**
             * @type string | undefined
            */
            endDate?: string;
            /**
             * @type string | undefined
            */
            description?: string;
            /**
             * @type string | undefined
            */
            value?: string;
            /**
             * @type string | undefined
            */
            referenceNumber?: string;
            /**
             * @type string | undefined
            */
            deliverable?: string;
            /**
             * @type string | undefined
            */
            deliveryMethod?: string;
            /**
             * @type string | undefined
            */
            division?: string;
            /**
             * @type string | undefined
            */
            details?: string;
            /**
             * @type string | undefined
            */
            imageUrl?: string;
            /**
             * @type string | undefined
            */
            workflowCount?: string;
            /**
             * @type string | undefined
            */
            archivedAt?: string;
            /**
             * @type string | undefined
            */
            status?: string;
            /**
             * @type string | undefined
            */
            itemCount?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3262Key;
                });
            };
            /**
             * @type object | undefined
            */
            archivedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3266Key;
                });
            };
            /**
             * @type object | undefined
            */
            sampleProjectTemplate?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3268Key;
                });
            };
            /**
             * @type object | undefined
            */
            client?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3261Key;
                });
            };
            /**
             * @type object | undefined
            */
            projectType?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3269Key;
                });
            };
            /**
             * @type object | undefined
            */
            owner?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3270Key;
                });
            };
            /**
             * @type object | undefined
            */
            architect?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3271Key;
                });
            };
            /**
             * @type object | undefined
            */
            department?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3272Key;
                });
            };
            /**
             * @type object | undefined
            */
            region?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3273Key;
                });
            };
            /**
             * @type object | undefined
            */
            projectLead?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3265Key;
                });
            };
            /**
             * @type object | undefined
            */
            createdBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3266Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3266Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3266Key;
                });
            };
            /**
             * @type object | undefined
            */
            createdByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3265Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3265Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3265Key;
                });
            };
            /**
             * @type object | undefined
            */
            externalLinks?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3274Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2199Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            fileUuid?: string;
            /**
             * @type string | undefined
            */
            originalName?: string;
            /**
             * @type string | undefined
            */
            fileName?: string;
            /**
             * @type string | undefined
            */
            mimeType?: string;
            /**
             * @type string | undefined
            */
            fileSize?: string;
            /**
             * @type string | undefined
            */
            checksum?: string;
            /**
             * @type string | undefined
            */
            bucket?: string;
            /**
             * @type string | undefined
            */
            fileKey?: string;
            /**
             * @type string | undefined
            */
            status?: string;
            /**
             * @type string | undefined
            */
            fileDocumentType?: string;
            /**
             * @type string | undefined
            */
            processingStartedAt?: string;
            /**
             * @type string | undefined
            */
            processingCompletedAt?: string;
            /**
             * @type string | undefined
            */
            pageCount?: string;
            /**
             * @type string | undefined
            */
            duration?: string;
            /**
             * @type string | undefined
            */
            dimensions?: string;
            /**
             * @type string | undefined
            */
            metadata?: string;
            /**
             * @type string | undefined
            */
            scopeType?: string;
            /**
             * @type string | undefined
            */
            version?: string;
            /**
             * @type string | undefined
            */
            versionName?: string;
            /**
             * @type string | undefined
            */
            versionDescription?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            isArchived?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3262Key;
                });
            };
            /**
             * @type object | undefined
            */
            createdBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3266Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3266Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3266Key;
                });
            };
            /**
             * @type object | undefined
            */
            createdByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3265Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3265Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3265Key;
                });
            };
            /**
             * @type object | undefined
            */
            rootFile?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3259Key;
                });
            };
            /**
             * @type object | undefined
            */
            versions?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3259Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2200Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
            /**
             * @type string | undefined
            */
            archivedAt?: string;
            /**
             * @type string | undefined
            */
            itemCount?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3262Key;
                });
            };
            /**
             * @type object | undefined
            */
            createdBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3266Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3266Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3266Key;
                });
            };
            /**
             * @type object | undefined
            */
            createdByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3265Key;
                });
            };
            /**
             * @type object | undefined
            */
            updatedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3265Key;
                });
            };
            /**
             * @type object | undefined
            */
            deletedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3265Key;
                });
            };
            /**
             * @type object | undefined
            */
            archivedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3266Key;
                });
            };
            /**
             * @type object | undefined
            */
            archivedByUser?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3265Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2201Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3256Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3262Key;
                });
            };
            /**
             * @type object | undefined
            */
            projects?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3258Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2202Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string
            */
            type: string;
            /**
             * @type string | undefined
            */
            parentId?: string;
            /**
             * @type string | undefined
            */
            path?: string;
            /**
             * @type string | undefined
            */
            depth?: string;
            /**
             * @type string | undefined
            */
            private?: string;
            /**
             * @type string | undefined
            */
            archivedAt?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            parent?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3262Key;
                });
            };
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3256Key;
                });
            };
            /**
             * @type object | undefined
            */
            team?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3257Key;
                });
            };
            /**
             * @type object | undefined
            */
            folder?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3260Key;
                });
            };
            /**
             * @type object | undefined
            */
            project?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3258Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2203Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            status?: string;
            /**
             * @type string | undefined
            */
            projectCount?: string;
            /**
             * @type string | undefined
            */
            projectCap?: string;
            /**
             * @type string | undefined
            */
            expiresAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: object;
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2204Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3256Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2205Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            email?: string;
            /**
             * @type string | undefined
            */
            firstName?: string;
            /**
             * @type string | undefined
            */
            lastName?: string;
            /**
             * @type string | undefined
            */
            phoneNumber?: string;
            /**
             * @type string | undefined
            */
            companyRole?: string;
            /**
             * @type string | undefined
            */
            acceptedTerms?: string;
            /**
             * @type string | undefined
            */
            termsAcceptedAt?: string;
            /**
             * @type string | undefined
            */
            lastLoginAt?: string;
            /**
             * @type string | undefined
            */
            timezone?: string;
            /**
             * @type string | undefined
            */
            avatarUrl?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            changeOrderAccess?: string;
            /**
             * @type string | undefined
            */
            trimbleSub?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            principal?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3266Key;
                });
            };
            /**
             * @type object | undefined
            */
            preferences?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3275Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2206Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            uuid?: string;
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            salesforceId?: string;
            /**
             * @type string | undefined
            */
            isActive?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: object;
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2207Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            displayName?: string;
            /**
             * @type string
            */
            type: string;
            /**
             * @type string | undefined
            */
            cognitoSubs?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            user?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3265Key;
                });
            };
            /**
             * @type object | undefined
            */
            memberships?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3276Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            createdFiles?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3259Key;
                }[];
            };
            /**
             * @type object | undefined
            */
            roles?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3277Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2208Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            status?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: object;
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2209Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3256Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3262Key;
                });
            };
            /**
             * @type object | undefined
            */
            projects?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3258Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2210Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3256Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3262Key;
                });
            };
            /**
             * @type object | undefined
            */
            projects?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3258Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2211Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3256Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3262Key;
                });
            };
            /**
             * @type object | undefined
            */
            projects?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3258Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2212Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3256Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3262Key;
                });
            };
            /**
             * @type object | undefined
            */
            projects?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3258Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2213Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string
            */
            name: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            organization?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3256Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3262Key;
                });
            };
            /**
             * @type object | undefined
            */
            projects?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3258Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2214Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            provider?: string;
            /**
             * @type string | undefined
            */
            externalCompanyId?: string;
            /**
             * @type string | undefined
            */
            externalProjectId?: string;
            /**
             * @type string | undefined
            */
            scopeId?: string;
            /**
             * @type string | undefined
            */
            metadata?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            project?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3258Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2215Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            currentTeamId?: string;
            /**
             * @type string | undefined
            */
            theme?: string;
            /**
             * @type string | undefined
            */
            language?: string;
            /**
             * @type string | undefined
            */
            timezoneOverride?: string;
            /**
             * @type string | undefined
            */
            dashboardLayout?: string;
            /**
             * @type string | undefined
            */
            onboardingStatus?: string;
            /**
             * @type string | undefined
            */
            onboardingGoals?: string;
            /**
             * @type string | undefined
            */
            onboardingCompletedAt?: string;
            /**
             * @type string | undefined
            */
            skillsEducationDismissedAt?: string;
            /**
             * @type string | undefined
            */
            onboardingTaskCompletions?: string;
            /**
             * @type string | undefined
            */
            onboardingTasksLoginViews?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            user?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3265Key;
                });
            };
            /**
             * @type object | undefined
            */
            currentTeam?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3257Key;
                });
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2216Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            membershipType?: string;
            /**
             * @type string | undefined
            */
            email?: string;
            /**
             * @type string | undefined
            */
            firstName?: string;
            /**
             * @type string | undefined
            */
            lastName?: string;
            /**
             * @type string | undefined
            */
            displayName?: string;
            /**
             * @type string | undefined
            */
            roleName?: string;
            /**
             * @type string | undefined
            */
            expiresAt?: string;
            /**
             * @type string | undefined
            */
            message?: string;
            /**
             * @type string | undefined
            */
            inviteStatus?: string;
            /**
             * @type string | undefined
            */
            isInherited?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            role?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3278Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3262Key;
                });
            };
            /**
             * @type object | undefined
            */
            principal?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3266Key;
                });
            };
            /**
             * @type object | undefined
            */
            user?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3265Key;
                });
            };
            /**
             * @type object | undefined
            */
            invitedBy?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3266Key;
                });
            };
            /**
             * @type object | undefined
            */
            inheritedFrom?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3262Key;
                });
            };
            /**
             * @type object | undefined
            */
            scopeAccess?: {
                /**
                 * @type array
                */
                data: {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3279Key;
                }[];
            };
        };
    } | {
        /**
         * @type string
        */
        id: string;
        type: IncludedTypeEnum2217Key;
        /**
         * @type object
        */
        attributes: {
            /**
             * @type string | undefined
            */
            expiresAt?: string;
            /**
             * @type string | undefined
            */
            scopeType?: string;
            /**
             * @type string | undefined
            */
            createdAt?: string;
            /**
             * @type string | undefined
            */
            updatedAt?: string;
            /**
             * @type string | undefined
            */
            deletedAt?: string;
        };
        /**
         * @type object | undefined
        */
        relationships?: {
            /**
             * @type object | undefined
            */
            principal?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3266Key;
                });
            };
            /**
             * @type object | undefined
            */
            scope?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3262Key;
                });
            };
            /**
             * @type object | undefined
            */
            role?: {
                data: (null | {
                    /**
                     * @type string
                    */
                    id: string;
                    type: DataTypeEnum3278Key;
                });
            };
        };
    })[];
    /**
     * @type object | undefined
    */
    meta?: PaginationMeta;
    /**
     * @type object | undefined
    */
    links?: JsonApiLinksDto;
};

/**
 * @description Unauthorized
*/
export type HierarchiesControllerGetDescendants401 = any;

/**
 * @description Forbidden - insufficient permissions
*/
export type HierarchiesControllerGetDescendants403 = any;

export type HierarchiesControllerGetDescendantsQueryResponse = HierarchiesControllerGetDescendants200;

export type HierarchiesControllerGetDescendantsQuery = {
    Response: HierarchiesControllerGetDescendants200;
    PathParams: HierarchiesControllerGetDescendantsPathParams;
    QueryParams: HierarchiesControllerGetDescendantsQueryParams;
    Errors: HierarchiesControllerGetDescendants401 | HierarchiesControllerGetDescendants403;
};